import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Brain, CheckCircle, Circle } from "lucide-react";

export function WeeklyCompletionTracker({ trainingPlans, planCompletions }) {
  return (
    <Card className="border-0 shadow-sm bg-gradient-to-br from-white to-teal-50/30">
      <CardHeader className="pb-2 pt-4 px-4 sm:px-6">
        <CardTitle className="text-base sm:text-lg text-emerald-900 flex items-center gap-2">
          <Brain className="w-5 h-5 text-emerald-600" />
          This Week's Mental Training
        </CardTitle>
        <CardDescription className="text-xs text-gray-500">
          Days complete when all active plans are done
        </CardDescription>
      </CardHeader>
      <CardContent className="pb-4 px-4 sm:px-6">
        <div className="flex items-center justify-between gap-1 sm:gap-3">
          {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => {
            const today = new Date();
            const dayOfWeek = today.getDay();
            const daysToMonday = (dayOfWeek === 0 ? -6 : 1 - dayOfWeek);
            const monday = new Date(today);
            monday.setDate(today.getDate() + daysToMonday);
            monday.setHours(0, 0, 0, 0);

            const activePlans = trainingPlans.filter(plan => planCompletions[plan.id] && planCompletions[plan.id].completed_days?.length > 0);
            const allPlansComplete = activePlans.length > 0 && activePlans.every(plan => {
              const weeklyProgress = planCompletions[plan.id];
              return weeklyProgress.completed_days?.includes(index);
            });

            const weekStartDate = new Date(monday);
            const currentDate = new Date(weekStartDate);
            currentDate.setDate(weekStartDate.getDate() + index);
            const dateNumber = currentDate.getDate();

            return (
              <div key={day} className="flex flex-col items-center flex-1">
                <span className="text-[10px] sm:text-xs font-medium text-gray-500">{day}</span>
                <span className="text-[9px] text-gray-400 mb-1">{dateNumber}</span>
                <div
                  className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 flex items-center justify-center transition-all ${
                    allPlansComplete
                      ? 'bg-emerald-500 border-emerald-500 text-white shadow-sm'
                      : 'bg-white border-gray-200 text-gray-300'
                  }`}
                >
                  {allPlansComplete
                    ? <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                    : <Circle className="w-4 h-4 sm:w-5 sm:h-5" />
                  }
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
